import styled from "styled-components";
import { FlexColumn, FlexRow } from "../Styles";

export const BackgroundImageContainer = styled(FlexColumn)`
  gap: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
  background: linear-gradient(
    116deg,
    #f4fbff 21.57%,
    rgba(230, 236, 255, 0) 76.26%
  );
  border-radius: ${({ theme }) => theme.radius["radius-xxs"].value}rem;
  padding: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
`;

export const AddImage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: ${({ theme }) => theme.spacing["spacing-12"].value}rem;
  height: ${({ theme }) => theme.spacing["spacing-12"].value}rem;
  padding: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
  border-radius: ${({ theme }) => theme.radius["radius-xs"].value}rem;
  background: ${({ theme }) =>
    theme.Color.background.brand.subtlest["default-hover"].value};
  cursor: pointer;
`;

export const Container = styled(FlexRow)`
  width: 100%;
  gap: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
  background: ${({ theme }) =>
    theme.Color.elevation.surface["surface-overlay"].value};
  border-radius: ${({ theme }) => theme.radius["radius-xxs"].value}rem;
  align-items: center;
  flex-wrap: wrap;
  padding: ${({ theme }) => theme.spacing["spacing-1"].value}rem;
`;

export const HiddenInput = styled.input`
  display: none;
`;
